import { render, staticRenderFns } from "./prev-common-text.vue?vue&type=template&id=4a18c691&scoped=true"
import script from "./prev-common-text.vue?vue&type=script&lang=js"
export * from "./prev-common-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a18c691",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a18c691')) {
      api.createRecord('4a18c691', component.options)
    } else {
      api.reload('4a18c691', component.options)
    }
    module.hot.accept("./prev-common-text.vue?vue&type=template&id=4a18c691&scoped=true", function () {
      api.rerender('4a18c691', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-block-form/components/prev-common-text.vue"
export default component.exports